// src/App.tsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { WhiteboardPage } from './pages/WhiteboardPage'; // Изменено: именованный импорт
import './styles/global.css';

function App() {
  return (
    <BrowserRouter basename="/tables">
      <Routes>
        {/* https://домен/tables?ui_id=... */}
        <Route path="/" element={<WhiteboardPage />} />
        {/* всё остальное → редирект на /tables */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;